"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var CheckBoxWithLabelWidget_1 = require("./CheckBoxWithLabelWidget");
var DomWidgets_1 = require("./DomWidgets");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
/** Controlled, stateless Check Box With Label Group Widget. */
var CheckBoxWithLabelGroupWidget = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBoxWithLabelGroupWidget, _super);
    function CheckBoxWithLabelGroupWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckBoxWithLabelGroupWidget.prototype.getContainerStyleOfIndex = function (index) {
        // no-op for parity with the RadioButtonWithLabelGroupWidget
        return {};
    };
    CheckBoxWithLabelGroupWidget.prototype.render = function () {
        var _this = this;
        return react_1.createElement(DomWidgets_1.Block, {
            role: 'group'
        }, this.props.checkBoxWithLabelPropsList.map(function (checkBoxWithLabelProps, index) {
            var containerStyle = tslib_1.__assign(tslib_1.__assign({}, checkBoxWithLabelProps.containerStyle), _this.getContainerStyleOfIndex(index));
            var newCheckBoxWithLabelProps = tslib_1.__assign(tslib_1.__assign({}, checkBoxWithLabelProps), { containerStyle: containerStyle, key: index });
            return react_1.createElement(CheckBoxWithLabelWidget_1.CheckBoxWithLabelWidget, newCheckBoxWithLabelProps);
        }));
    };
    return CheckBoxWithLabelGroupWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.CheckBoxWithLabelGroupWidget = CheckBoxWithLabelGroupWidget;
//# sourceMappingURL=CheckBoxWithLabelGroupWidget.js.map